import { Suspense, lazy, startTransition } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { Auth0Provider } from "@auth0/auth0-react";
import store, { persistor } from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import Loader from "./component/Loader";
// import best_logo from "../src/image/best_logo.webp"; // ✅ preload ke liye alag se use karein

// ✅ Lazy load the main AppWrapper – isse yeh alag chunk mein aayega
const AppWrapper = lazy(() => import("./AppWrapper.jsx"));

const root = ReactDOM.createRoot(document.getElementById("root"));

// ✅ startTransition se render non-blocking ho jata hai
startTransition(() => {
  root.render(
    <Auth0Provider
      domain="sharukhmirza88.us.auth0.com"
      clientId="XQF85FTYI87P9tX4z18Nlw1npy1N8Bnx"
      authorizationParams={{ redirect_uri: window.location.origin }}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <Loader />
                <small>Loading...</small>
              </div>
            }
          >
            <AppWrapper />
          </Suspense>
        </PersistGate>
      </Provider>
    </Auth0Provider>
  );
});